<template>
  <div v-if="show"
       class="audio-welfare-btn-component"
       :class="{ 'in-app': isAppWebView }"
       :style="widthStyle"
       @click="handleExchangeWelfare"
       v-ym-report:NEW_USER_GIFT_CLICK=""
  >
    <ym-img class="welfare-icon"
            :style="widthStyle"
            :src="src"
            alt="领取福利"
    />
  </div>
</template>

<script>

  import { addUnit, isAppWebView, locationHref } from '@/utils';

  export default {
    name: 'AudioWelfareBtn',
    props: {
      show: {
        type: Boolean,
        required: true,
        default: false,
      },
      src: {
        type: String,
        required: true,
      },
      url: {
        type: String,
        required: true,
      },
      width: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        isAppWebView: isAppWebView(),
      };
    },
    computed: {
      widthStyle() {
        const result = {};
        result.width = `${addUnit(this.width)}`;
        return result;
      },
    },
    methods: {
      handleExchangeWelfare() {
        locationHref(this.url);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .audio-welfare-btn-component {
    position: fixed;
    bottom: 200px;
    left: 50%;
    margin-left: 750/2 - 180px;
    z-index: @z-index-extra-extra-large;
    &.in-app {
      left: auto;
      right: 3vw;
      margin-left: 0;
    }
  }

  .welfare-icon {
    display: inline-block;
  }
</style>
